module.exports = __webpack_public_path__ + "img/headset.5795ac61.png";